<template>
    <button
        :aria-current="isCurrentGroup ? 'step' : false"
        :disabled="disabled"
        :class="[
            headerFontClass,
            { cz2__alert: alert },
            { 'cz2__muted-more': disabled },
            { 'cz2__main-navigation-list-button--current': isCurrentGroup },
        ]"
        ref="button"
        class="cz2__main-navigation-list-button"
    >
        <div
            :class="[
                { cz2__alert: alert },
            ]"
            class="cz2__main-navigation-list-button-content-wrapper"
        >
            <span
                v-html="groupName"
                class="cz2__main-navigation-list-button-content"
            />

            <img
                v-if="alert"
                src="../assets/icons/alert.svg"
                alt="Warning"
                class="cz2__main-navigation-list-button-alert"
            />
        </div>
    </button>
</template>

<style lang="scss">
    @import "../style/variables.scss";
    @import "../style/shared.scss";

    #cz2.cz2 {
        .cz2__main-navigation-list-button {
            position: relative;

            outline: none;

            width: 100%;

            text-align: left;
            font-size: 32px;
            text-transform: uppercase;
            font-style: italic;
            color: color(primaryWhite);

            &:not(.cz2__alert) {
                &:focus {
                    outline: none;

                    &:before {
                        position: absolute;
                        top: -3px;
                        left: -11px;

                        width: calc(100% + 6px);
                        height: calc(100% + 6px);
                        content: '';
                        clip-path: polygon(0 0, 100% 8%, 97% 90%, 2% 100%);
                        background-color: color(primaryWhite);
                    }
                }
            }

            &.cz2__alert {
                &:focus {
                    .cz2__main-navigation-list-button-content-wrapper {
                        &:before {
                            background-color: white;
                        }
                    }
                }
            }

            .cz2__main-navigation-list-button-content-wrapper {
                position: relative;

                filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25));

                padding: 0px 16px;
                width: 100%;

                display: flex;

                &:before,
                &:after {
                    position: absolute;

                    width: 100%;
                    content: '';
                    clip-path: polygon(0 0, 100% 8%, 97% 90%, 2% 100%);
                }

                &:not(.cz2__alert):before {
                    left: -8px;

                    height: 100%;
                    background-color: color(v2Red);
                }

                &.cz2__alert {
                    width: 97%;
                    color: black;

                    &:before {
                        top: -2px;
                        left: -10px;

                        height: calc(100% + 4px);

                        background-color: black;
                    }

                    &:after {
                        left: -8px;

                        height: 100%;

                        background-color: color(v2Yellow);
                    }

                    .cz2__main-navigation-list-button-content {
                        z-index: 2;
                    }
                }
            }

            .cz2__main-navigation-list-button-content {
                position: relative;

                display: flex;
            }

            .cz2__main-navigation-list-button-alert {
                position: absolute;
                top: -6px;
                right: -10px;
                z-index: 1;

                width: 57px;
                height: 49px;
            }

            &:disabled {
                cursor: not-allowed;
            }

            @include respond-above(xl) {
                font-size: 50px;

                .cz2__main-navigation-list-button-alert {
                    right: -17px;

                    width: 75px;
                    height: 70px;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk{
        .cz2__main-navigation-list-button-content {
            font-size: 81px;

            width: var(--vw100, 100vw);

            margin-top: 3px;
            margin-bottom: 3px;
        }

        .cz2__main-navigation-list-button-alert {
            top: 0;
            right: -36px;

            width: auto;
            height: 108px;
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2__is-sb {
        .cz2__main-navigation-list-button-content {
            font-size: 20px;
            margin-top: 3px;
            margin-bottom: 3px;

            @include respond-above(md) {
                font-size: 30px;
            }

            @include respond-above-height(lg, short) {
                font-size: 40px;
            }

            @include respond-above-height(lg, medium) {
                font-size: 50px;
            }
        }
        .cz2__main-navigation-list-button-content-wrapper {
            padding: 0 8px;
            font-style: normal;
            text-transform: none;

            border: 1px solid color(primaryWhite);
            box-shadow: 0px 0px 0px 3px color(sbDarkGold);

            &:focus {
                outline: none;

                &:before {
                    height: 100%;
                    content: '';
                    clip-path: none !important;
                    background-color: color(primaryWhite);
                }
            }

            &:before {
                left: 0 !important;
                height: 100%;
                content: '';
                clip-path: none !important;
                background-color: color(sbDarkBlue) !important;
            }

            &.cz2__alert {
                width: 100% !important;

                .cz2__main-navigation-list-button-alert {
                    @include respond-below(sm) {
                        top: -11px;
                    }
                }

                &:before {
                    background-color: #f7ab47 !important;
                    height: 100% !important;
                    top: 0 !important;
                }

                &:after {
                    display: none;
                    ;
                    clip-path: none !important;

                    left: 4px;
                    width: calc(100% - 8px);
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk.cz2__is-sb {
        .cz2__main-navigation-list-button-content {
            font-size: 69px;
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__main-navigation-list-button-content-wrapper {
            &:not(.cz2__alert):before {
                background-color: #000;
            }
        }

        .cz2__main-navigation-list-button--current {
            .cz2__main-navigation-list-button-content-wrapper {
                color: black;
                &:not(.cz2__alert):before {
                    background-color: color(knicksYellow);
                }
            }
        }
    }
</style>

<script>
    import * as constants from '../constants';

    export default {
        props: {
            group: Object,
            activePopId: String,
            alert: Boolean,
            disabled: Boolean,
            shouldFocusOnLoad: Boolean,
        },

        mounted() {
            if (this.shouldFocusOnLoad) {
                this.$nextTick(() => {
                    this.$refs.button.focus();
                });
            }
        },

        computed: {
            currentGroupName() {
                return this.mapBabiesGroupName(this.$store.state.customizer.currentGroup.name);
            },

            groupName() {
                if (this.group == null) {
                    return null;
                }

                return this.mapBabiesGroupName(this.group.name);
            },

            isCurrentGroup() {
                return this.groupName.includes(this.currentGroupName);
            },

            isBaby() {
                const activePopController = this.$store.getters.popControllers.find((x) => x.id === this.activePopId);
                const body = activePopController?.selectedAtPlacement(constants.PLACEMENT_BODY);

                return body?.custom?.['fun-baby'] === 'true';
            },

            headerFontClass() {
                return this.$store.getters.headerFontClass;
            },
        },

        methods: {
            mapBabiesGroupName(name) {
                if (this.isBaby && (name === 'Lashes' || name === 'Head')) {
                    return this.$t('STEP_HEAD_BABY');
                }

                return name;
            },
        },
    };
</script>
